import { LocalStorageStore } from './LocalStorageStore';

export const IdentityTokenStore = new LocalStorageStore<string>(
  'IDENTITY_TOKEN_STORE',
  (x) => x,
  (x) => x,
);
